// ****************************************************************************************
//  Pungo component
//   
//  This component dynamically generates buttons based on a provided list of names. 

//  When a button is selected, the onSelect function returns both the selected
//  option's name and its index within the original list. 

//  The parent component, which invokes this component, is expected to have a function 
//  with the same signature to handle the returned values (option name and index), 
//  typically to update a variable in its own state. 
// 
//  Additionally, the component accepts a minimum width prop for the buttons.
// ****************************************************************************************


import React, { useState } from "react";

import styles from "./index.module.scss";

interface PungoOptionSelectionByButtonProps {
  names: string[];
  onSelect: any;
  minWidth: number;
}

const PungoOptionSelectionByButton: React.FC<PungoOptionSelectionByButtonProps> = (props) => {
  const { names, onSelect, minWidth } = props;

  const [selectedIndex, setSelectedIndex] = useState<number | null>(0);

  const handleButtonClick = (index: number, name: string) => {
    setSelectedIndex(index);
    onSelect(index, name);
  };

  return (
    <div className={styles.chartContainer}>
      <div className={styles.chartMenuContainer}>
        {names.map((name, index) => (
          <div className={styles.chartMenuButtonContainer}>
            <button key={index} onClick={() => handleButtonClick(index, name)} className={selectedIndex === index ? styles.chartButtonActive : styles.chartButton} style={{ minWidth: minWidth }}>
              {name}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PungoOptionSelectionByButton;
